import { Card, Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import ComponentTextInput from '../../../../Common/ComponentTextinput/ComponentTextInput';
import { ASMESectionVEnum, FourthComponentProps } from '../../utils/type';
import ComponentSelectInput from '../../../../Common/ComponentSelectInput';
import { ProbeScanValues } from '../../utils/constant';
import localStorageConstants from '../../../../utils/LocalStorageConstants';
import { ANALYST_ROLE_ID } from '../../../../Routes/constant';
import { RootState } from '../../../../redux/rootState';

export default function FourthComponent({ control, errors }:FourthComponentProps) {
  const roleId = localStorage.getItem(localStorageConstants.ROLE_ID);
  const { isASMESection } = useSelector((state: RootState) => state.VesselMainReducer);

  return (
    <Card>
      <div className="customerInfo_container">
        <div className="customerInfo">
          {' '}
        </div>
      </div>
      <div className="customerInfo_main_container">
        <Grid container spacing={2}>
          <Grid item md={4} sm={6} xs={12}>
            <div className="div_label_text">
              <label className={roleId === ANALYST_ROLE_ID || !isASMESection ? 'label_Disable' : 'label_Style_Customer'}>
                Probe Mfg
              </label>
              <ComponentTextInput
                control={control}
                capitalizeFirst
                isDisable={roleId === ANALYST_ROLE_ID || !isASMESection}
                inputProps={{ maxLength: 30 }}
                name={ASMESectionVEnum.probeMfg}
                id={ASMESectionVEnum.probeMfg}
                size="small"
                errors={errors}
              />
            </div>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <div className="div_label_text">
              <label className={roleId === ANALYST_ROLE_ID || !isASMESection ? 'label_Disable' : 'label_Style_Customer'}>
                Probe Serial Number
              </label>
              <ComponentTextInput
                control={control}
                capitalizeFirst
                isDisable={roleId === ANALYST_ROLE_ID || !isASMESection}
                inputProps={{ maxLength: 30 }}
                name={ASMESectionVEnum.probeSerialNumber}
                id={ASMESectionVEnum.probeSerialNumber}
                size="small"
                errors={errors}
              />
            </div>
          </Grid>
          <Grid item md={4} sm={6} xs={12}>
            <div className="div_label_text">
              <label className={roleId === ANALYST_ROLE_ID || !isASMESection ? 'label_Disable' : 'label_Style_Customer'}>
                Probe Scan Direction
              </label>
              <ComponentSelectInput
                name={ASMESectionVEnum.probeScanDirection}
                control={control}
                disabled={roleId === ANALYST_ROLE_ID || !isASMESection}
                size="small"
                entries={ProbeScanValues}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </Card>
  );
}
